import { render, staticRenderFns } from "./NotificationViewDetail.vue?vue&type=template&id=2301050f&"
import script from "./NotificationViewDetail.vue?vue&type=script&lang=ts&"
export * from "./NotificationViewDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports